import { ForwardedRef, forwardRef, MutableRefObject } from 'react';
import { Button, Modal, Theme } from '@/theme/index';

export interface ActionModalProps {
  children: JSX.Element | JSX.Element[];
  buttonProps: Record<string, unknown>[];
  open: boolean;
  handleClose: () => unknown;
  containerRef: MutableRefObject<null>;
  overridePaperStyles?: Record<
    string,
    string | number | Record<string, string | number>
  >;
}

export const ActionModal = forwardRef(
  (
    {
      children,
      buttonProps,
      open,
      handleClose,
      containerRef,
      overridePaperStyles,
    }: ActionModalProps,
    ref: ForwardedRef<null>
  ) => {
    const actionButtons = buttonProps.map((buttonProps, index) => (
      <Button key={index} sx={{ flex: 1 }} {...buttonProps} color="success" />
    ));
    const paperProps = {
      sx: (theme: Theme) => ({
        boxShadow: '0px 3px 5px 0px #75757540',
        border: '1px solid #E2E2E2',
        maxWidth: 288,
        maxHeight: 'unset',
        position: 'absolute',
        bottom: theme.spacing(6.25),
        left: 0,
        margin: 0,
        ...overridePaperStyles,
      }),
    };
    return (
      <Modal
        container={() => containerRef.current}
        open={open}
        onClose={handleClose}
        hideBackdrop
        hasCloseIcon={false}
        PaperProps={paperProps}
        sx={{
          position: 'absolute',
          height: 'unset',
          zIndex: 9,
        }}
        actions={actionButtons}
        ref={ref}
        disableScrollLock
      >
        {children}
      </Modal>
    );
  }
);
